import React, { useContext } from 'react';
import styles from './PaperlessPush.styles.js';
import usePaperlessPushHook from './PaperlessPush.hook.js';
import DefaultLayout from 'Components/DefaultLayout/DefaultLayout.jsx';
import { AppContext } from 'App.context.js';
import AppButton from 'Components/common/Forms/AppButton/AppButton.jsx';
import BaseTable from 'Components/common/BaseTable/BaseTable.jsx';
import PaperlessPushTable from './PaperlessPush.table';
import './PaperlessPush.css';
import AppModal from 'Components/common/AppModal/AppModal.jsx';
import EditDeviceModal from './editDeviceModal.js';
export default function PaperlessPush() {
  const {
    appState,
    appActions: { translate },
  } = useContext(AppContext);
  const { state, actions } = usePaperlessPushHook();

  const COLUMNS = PaperlessPushTable.getPaperlessPushColumns({
    actions,
    translate,
    setPMSId: actions.setPMSId,
    setIpWhitelist: actions.setHotelWhitelist,
    isValidIpList: actions.isValidIpList,
    getExampleLink: actions.getExampleLink,
    goToAccountDetail: actions.goToAccountDetail,
    getApiPaperlessCrendetials: actions.getApiPaperlessCrendetials,
    paperlessDevices: state.paperlessDevices,
    apiPaperlessStatus: state.apiPaperlessStatus,
    appState,
  });

  return (
    <DefaultLayout singleBox title={translate('paperlessPush.title')}>
      <div>
        <div style={styles.header}>
          <AppButton
            text={translate('save')}
            action={actions.onSaveClicked}
            disabled={state.isLoading}
          />
        </div>

        <div style={styles.tableContainer}>
          <div style={styles.table}>
            <BaseTable
              data={state.dataSource}
              columns={COLUMNS}
              loading={state.isLoading}
              onChange={filters => actions.onChange(filters)}
              onRowClicked={actions.onRowClicked}
              removeCellPadding={true}
            />
          </div>
        </div>
        <AppModal // delete device
          show={state.deleteDeviceWarning}
          title={translate('policeReport.sideItem.delete.warning.title')}
          description={translate('policeReport.sideItem.delete.warning.description')}
          okText={translate('Ok')}
          okAction={actions.onDeletePaperlessDevice}
          cancelAction={() => actions.setShowDeleteDevice(false)}
          closable={false}
        />
        {state.showEditDeviceModal &&
          (['admin', 'owner'].includes(appState.role) || appState.superUser) && (
            <EditDeviceModal state={state} actions={actions} translate={translate} />
          )}
      </div>
    </DefaultLayout>
  );
}
